var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-edit',{ref:"cardEditComp",attrs:{"source-data":_vm.sourceData,"schema":_vm.CREDIT_RISKING_SCHEMA,"gutter":_vm.gutter}})}
var staticRenderFns = []

export { render, staticRenderFns }